<app-lfsa-card [innTemplate]="Actulizar" [titulo]="titulo" [efecto]="true"
                  [colapseName]="'carga'" [banderaColapse]='false'
                  [optionsExport]="true" (devolverAccion)="exportCSV($event)">
</app-lfsa-card>

<ng-template #Actulizar>
  <form [formGroup]="formulario" novalidate class="form-group">
    <div class="row">
      <div class="col-sm-6 col-md-6  col-xl-2" *ngIf="!habilitaFiltros" >
        <app-lfsa-input [control]="formulario.get('numeroSemana')" [claseLabel]="'letrasDefault'" 
                        formControlName="numeroSemana" [label]="'Número Semana'" [type]="'number'" [id]="'numeroSemana'">
        </app-lfsa-input>
      </div>
      
      <div class="col-sm-6 col-md-6  col-xl-2" *ngIf="!habilitaFiltros" >
        <label for="usuario">Usuario</label>
          <select class="form-control" formControlName="usuario" name="usuario">
            <option value="">-- Seleccione --</option>
            <option *ngFor="let usuario of usuariosList" [value]="usuario.idUsuario">{{usuario.nombre}} {{usuario.apellido}}</option>
          </select>
      </div>

      <div class="form-group col-md-2" *ngIf="habilitaFiltros">
        <app-lfsa-input [control]="formulario.get('fechaInicio') | formControl"
                        (change)='obtainDate()'
                        [id]="'fechaInicio'"
                        [label]="'Fecha Inicio*'" [mostrarImg]="false" [placeholder]="'Fecha inicio'"
                        [type]="'date'"
                        formControlName="fechaInicio">
        </app-lfsa-input>
      </div>

      <div class="form-group col-md-2" *ngIf="habilitaFiltros">
        <app-lfsa-input [control]="formulario.get('fechaFin') | formControl"
                        (change)='obtainDate()'
                        [id]="'fechaFin'"
                        [label]="'Fecha Fin*'" [mostrarImg]="false" [placeholder]="'Fecha fin'"
                        [type]="'date'"
                        formControlName="fechaFin">
        </app-lfsa-input>
      </div>

      <div class="col-sm-6 col-md-6 col-xl-2">
        <div *ngIf="habilitaFiltros">
          <label>&nbsp;</label><br>
          <button class="btn btn-info btn-block" [disabled]="formulario.invalid" (click)="verFiltros()">{{textoFiltros}}</button>
        </div>
      </div>

      <div class="col-sm-6 col-md-6 col-xl-2">
        <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>
        <div *ngIf="!loading">
          <label>&nbsp;</label><br>
          <button class="btn btn-success btn-block" [disabled]="formulario.invalid" (click)="ejecutar()">Consultar</button>
        </div>
      </div>

    </div>
  </form>
  
  <br>
  <div class="row">
    <div class="col-md-12 ">
      <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>

      <div *ngIf="!loading">
        <div class="alert alert-danger animated fadeInRight" role="alert" *ngIf="listaVacia">
          No existen datos para el Log de Perform
        </div>

        <ag-grid-angular *ngIf="!listaVacia" 
          #agGrid class="{{diccionarioModulo.agGrid.class}}"  [floatingFilter]="true"
          [ngStyle]="diccionarioModulo.agGrid.style" id="{{diccionarioModulo.agGrid.id}}"
          [frameworkComponents]="frameworkComponents " [columnDefs]="columnDefs" [rowSelection]="rowSelection"
          [rowData]="rowData" (gridReady)="onGridReady($event)" [pagination]="true"
          [paginationPageSize]="diccionarioModulo.agGrid.paginacion">
        </ag-grid-angular>

      </div>

    </div>
  </div>

</ng-template>